import { createModel } from '@rematch/core';
import { RootModel } from './RootState';
import { PageInfo } from '../models/PageInfo';

export type ContextState = {
    pageInfo: PageInfo;
};

const initialState: ContextState = {
    pageInfo: {
        type: 'general',
        url: '',
        locale: 'es',
        currency: 'EUR'
    }
};

export const contextState = createModel<RootModel>()({
    state: initialState,
    reducers: {
        setPageInfo(state, pageInfo: PageInfo) {
            return { ...state, pageInfo };
        }
    }
});
